import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Header.css';
import AuthModal from '../Modals/AuthModals';
import SweetAlert from "react-bootstrap-sweetalert";
import { ApiService } from '../Services/apiServices';


const Header = () => {
    const [authmodals, setAuthModals] = useState(false);
    const [user, setUser] = useState(null);
    const [showLogoutAlert, setShowLogoutAlert] = useState(false);
    const [settings, setSettings] = useState("");



    const handleClose = () => {
        setAuthModals(false);
    };

    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            setUser(JSON.parse(userData));
        }
        fetchsettings();
    }, []);

    const fetchsettings = async () => {
        try {
            const settingData = await ApiService.Commanfetchrequest('setting');
            setSettings(settingData);
            // console.log('setting data:', settingData);
        } catch (error) {
            console.log('error while fetching:', error);
        }
    }


    const handleLogoutClick = () => {
        setShowLogoutAlert(true);
    };

    const confirmLogout = () => {
        setShowLogoutAlert(false);
        handleLogout();
        window.location.reload();
    };

    const handleLogout = () => {
        localStorage.removeItem("USER_DATA");
        setUser(null);
    };


    return (
        <>
            <div className="container-fluid bg-dark px-0 mobile-fixed-header">
                <div className="row gx-0">
                    <div className="col-lg-3 bg-dark d-none d-lg-block">
                        <Link to="/" className="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
                            <h1 className="m-0" style={{ color: "#FEA116" }}>{settings?.site_name}</h1>
                        </Link>
                    </div>
                    <div className="col-lg-9">
                        <div className="row gx-0 bg-white d-none d-lg-flex">
                            <div className="col-lg-7 px-5 text-start">
                                <div className="h-100 d-inline-flex align-items-center py-2 me-4">
                                    <i className="fa fa-envelope text-primary me-2" />
                                    <p className="mb-0"><a style={{ textDecoration: "none", color: "black" }} href='{"mailto:" + settings?.site_email}'>{settings?.site_email || 'info@example.com'}</a></p>
                                </div>
                                <div className="h-100 d-inline-flex align-items-center py-2">
                                    <i className="fa fa-phone-alt text-primary me-2" />
                                    <p className="mb-0"><a style={{ textDecoration: "none", color: "black" }} href='{"tel:" + settings?.site_phone}'>{settings?.site_phone || '+1 5589 55488 55'}</a></p>
                                </div>
                            </div>
                            <div className="col-lg-5 px-5 text-end">
                                <div className="d-inline-flex align-items-center py-2">
                                    {settings?.facebook_url != null ? (
                                        <Link to={settings?.facebook_url} target='new' className="me-3" >
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                    ) : (
                                        ""
                                    )}

                                    {settings?.twitter_url != null ? (
                                        <Link to={settings?.twitter_url} target='new' className="me-3" >
                                            <i className="fab fa-twitter" />
                                        </Link>
                                    ) : (
                                        ""
                                    )}
                                    {settings?.instagram_url != null ? (
                                        <Link to={settings?.instagram_url} target='new' className="me-3" >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                        <nav className="navbar navbar-expand-lg bg-dark navbar-dark p-3 p-lg-0">
                            <Link to="/" className="navbar-brand d-block d-lg-none">
                                <h1 style={{ color: "#FEA116" }} className="m-0">{settings?.site_name}</h1>
                            </Link>

                            {user ? (
                                <Link to="/account" className="d-block d-lg-none me-3">
                                    <i className="fa fa-user text-white fs-4" style={{ marginLeft: "20px" }}></i>
                                </Link>
                            ) : (
                                <Link className="d-block d-lg-none me-3" onClick={() => { setAuthModals(true) }}>
                                    <i className="fa fa-user text-white fs-4" style={{ marginLeft: "20px" }}></i>
                                </Link>
                            )}


                            <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                                <span className="navbar-toggler-icon" />
                            </button>
                            <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
                                <div className="navbar-nav mr-auto py-0">
                                    <Link to="/" className="nav-item nav-link active">Home</Link>
                                    <Link to="/about-us" className="nav-item nav-link">About</Link>
                                    <Link to="/services" className="nav-item nav-link">Services</Link>
                                    <Link to="/rooms" className="nav-item nav-link">Rooms</Link>
                                    <Link to="/contact-us" className="nav-item nav-link">Contact</Link>
                                </div>

                                {user ? (
                                    <div className="dropdown d-none d-md-block" style={{ marginRight: "30px" }}>
                                        <button
                                            className="btn btn-light dropdown-toggle px-3 py-2 fw-bold text-dark"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            style={{ borderRadius: "8px", border: "1px solid #ddd", minWidth: "150px" }}
                                        >
                                            {user?.username}
                                        </button>
                                        <ul
                                            className="dropdown-menu dropdown-menu-end mt-2"
                                            aria-labelledby="dropdownMenuButton"
                                            style={{ minWidth: "150px", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                                        >
                                            <li>
                                                <p className="dropdown-item" style={{ fontWeight: "600" }}>
                                                    Welcome back ! {user?.username}
                                                </p>
                                            </li>
                                            <hr style={{ color: "black" }} />
                                            <li>
                                                <Link className="dropdown-item py-2" to="/account">
                                                    <i className="fa fa-user-circle me-2"></i> Account
                                                </Link>
                                            </li>
                                            <li>
                                                <button
                                                    className="dropdown-item text-white fw-bold mt-3 logout-btn"
                                                    onClick={handleLogoutClick}
                                                    style={{
                                                        backgroundColor: "#dc3545",
                                                        borderRadius: "5px",
                                                        textAlign: "center",
                                                        transition: "background-color 0.3s ease-in-out"
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#b02a37")}
                                                    onMouseLeave={(e) => (e.target.style.backgroundColor = "#dc3545")}                                             >
                                                    <i className="fa fa-sign-out-alt me-2"></i> Logout
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                ) : (
                                    <Link
                                        style={{
                                            backgroundColor: "#FEA116",
                                            color: "#fff",
                                            fontWeight: "600",

                                        }}
                                        onClick={() => setAuthModals(true)}
                                        className="btn btn-warning rounded-0 py-4 px-md-5 d-none d-lg-block"
                                    >
                                        Account Login <i className="fa fa-arrow-right ms-2" />
                                    </Link>
                                )}

                            </div>
                        </nav>
                    </div>
                </div>
            </div>

            {showLogoutAlert && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, Logout"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={confirmLogout}
                    onCancel={() => setShowLogoutAlert(false)}
                    focusCancelBtn
                >
                    You will be logged out of your account.
                </SweetAlert>
            )}

            <AuthModal show={authmodals} handleClose={handleClose} />
        </>
    );
};

export default Header;
